import { clamp } from 'es-toolkit';
import type { DateTime, DurationUnit } from 'luxon';
import type { ComputeRelativeProps } from './types';
import { DAYS, HOURS, MILLISECONDS, MINUTES, SECONDS } from './units';

const UNITS: DurationUnit[] = [DAYS, HOURS, MINUTES, SECONDS];

export function computeRelative(
  dateTime: DateTime,
  { active, always, interval, observe }: ComputeRelativeProps = {}
) {
  const isRelative =
    !!active && (inRelativeInterval(dateTime, interval) || always);
  const relativeObserverTimeout =
    isRelative && observe ? getRelativeTimeout(dateTime) : null;

  return { isRelative, relativeObserverTimeout };
}

function inRelativeInterval(
  dateTime: DateTime,
  { unit = DAYS, value = 7 }: ComputeRelativeProps['interval'] = {}
) {
  const limitDiff = dateTime.diffNow(unit).get(unit);

  return Math.abs(limitDiff) <= value;
}

function getRelativeTimeout(dateTime: DateTime) {
  let timeout = 1000;

  [...UNITS].some((unit) => {
    const count = dateTime.diffNow(unit).get(unit);
    const useThisUnit = Math.abs(count) >= 1;

    if (useThisUnit) {
      timeout = Math.floor(dateTime.diffNow(unit).as(MILLISECONDS) / count);

      if (clamp(timeout, 999, 1001)) {
        // round to 1000, since the previous interval may not be exec exactly in 1000ms
        timeout = 1000;
      }
    }

    return useThisUnit;
  });

  return timeout;
}
